module.exports = __webpack_public_path__ + "static/media/chevron-right.545b606b.svg";